import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountDTO  {
    _originalTypeClassName = "zPMO.BO.AccountDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountDTO.translate = translateService;
}
this.Email = null;
this.AFM = null;
this.PhoneNumber = null;
this.Name = null;
this.Surname = null;
this.CompanyName = null;
this.AccountDTOKey = null;
this._key = this.AccountDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Email:any;
AFM:any;
PhoneNumber:any;
Name:any;
Surname:any;
CompanyName:any;
private _AccountDTOKey:any;
get AccountDTOKey(): any {
    return this._AccountDTOKey;
  }
set AccountDTOKey(value: any) {
    this._AccountDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountDTOKey == null || $this.AccountDTOKey == 0;
            }


}